/* BeanBurds Coffee PDP — North Star v1 re-skin (P1, 27 Jul 2026).
   Rewrites the interaction layer for the new markup while preserving the
   exact cart contract from the previous build:
     - POST /cart/add.js with selling_plan + (grind as a line-item property
       when it isn't a real variant option)
     - NO GA4 add_to_cart here — the Tinker parent theme fires its own on any
       /cart/add.js and a second would double-count.
     - dispatches cart:refresh / cart:change so the parent's cart drawer updates.

   Dropped from the previous build (deliberate, flagged in the close-out
   report): the standalone coffee-calculator drawer and the grind-guide sheet.
   Neither is part of the North Star v1 spec; keeping them would have carried
   scope this session wasn't asked to rebuild. Accordions no longer need JS at
   all — they're native <details>, styled, zero script.

   All data comes from the JSON blob in #bbp-data, emitted by
   sections/bb-pdp-coffee.liquid.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-bbp-root]');
  if (!root) return;
  var BT = window.BBT || {}; function tt(k, d, o) { var s = BT[k] || d; if (o) { for (var x in o) { s = s.split('{' + x + '}').join(o[x]); } } return s; }

  var dataEl = document.getElementById('bbp-data');
  if (!dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var VARIANTS = DATA.variants || [];
  var PLANS = DATA.sellingPlans || [];
  var MONEY_FMT = DATA.moneyFormat || 'AED {{amount}}';
  var REQUIRES_PLAN = !!DATA.requiresSellingPlan;

  var $ = function (id) { return root.querySelector('#' + id); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* ---------- money ---------- */
  function money(cents) {
    var v = cents / 100;
    var s = (Math.round(v * 100) % 100 === 0) ? String(Math.round(v)) : v.toFixed(2);
    return MONEY_FMT.replace(/\{\{\s*amount[^}]*\}\}/, s);
  }

  /* ---------- state ---------- */
  var state = {
    size: DATA.initialSize,
    grind: DATA.initialGrind,
    plan: REQUIRES_PLAN ? 'sub' : 'once',
    planId: PLANS.length ? String(PLANS[0].id) : null,
    qty: 1
  };

  function currentPlan() {
    for (var i = 0; i < PLANS.length; i++) {
      if (String(PLANS[i].id) === String(state.planId)) return PLANS[i];
    }
    return PLANS[0] || { pct: 0, name: '' };
  }

  /* Match on the option values actually selected, so this works no matter which
     option position the merchant assigned to Size / Grind. */
  function currentVariant() {
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (String(v.size) === String(state.size) && String(v.grind) === String(state.grind)) return v;
    }
    for (var j = 0; j < VARIANTS.length; j++) {
      if (String(VARIANTS[j].size) === String(state.size)) return VARIANTS[j];
    }
    return VARIANTS[0];
  }

  function oncePrice() { var v = currentVariant(); return v ? v.price : 0; }

  function subPrice() {
    var v = currentVariant();
    if (v && v.planPrices && v.planPrices[state.planId] != null) return v.planPrices[state.planId];
    return Math.round(oncePrice() * (100 - currentPlan().pct) / 100);
  }

  function unitPrice() { return state.plan === 'sub' ? subPrice() : oncePrice(); }

  function setText(id, txt) { var el = $(id); if (el) el.textContent = txt; }
  /* Arabic pages: prices carry the dirham symbol (inline SVG from the section) */
  var CUR_HTML = DATA.curHtml || '';
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function moneyHtml(cents) { return CUR_HTML ? CUR_HTML + esc(money(cents)) : esc(money(cents)); }
  function setMoney(id, cents) { var el = $(id); if (!el) return; if (CUR_HTML) el.innerHTML = moneyHtml(cents); else el.textContent = money(cents); }

  function update() {
    var v = currentVariant();
    var u = unitPrice();
    var plan = currentPlan();

    setMoney('bbPrice', u);
    setMoney('oncePrice', oncePrice());
    setMoney('subPrice', subPrice());
    setText('planSave', BT.save_pct ? tt('save_pct', '', { pct: plan.pct }) : 'Save ' + plan.pct + '%');
    setText('sizePicked', v ? v.sizeLabel : '');
    setText('qtyVal', state.qty);

    var atc = $('atcBtn');
    var soldOut = v && v.available === false;
    if (atc) {
      atc.disabled = !!soldOut;
      if (CUR_HTML) {
        atc.innerHTML = soldOut
          ? esc(tt('sold_out', 'Sold out'))
          : esc(state.plan === 'sub' ? tt('subscribe', 'Subscribe') : tt('add_to_bag', 'Add to bag')) + ' · ' + moneyHtml(u * state.qty);
      } else {
      atc.textContent = soldOut
        ? tt('sold_out', 'Sold out')
        : (state.plan === 'sub'
            ? tt('subscribe', 'Subscribe') + ' · ' + money(u * state.qty)
            : tt('add_to_bag', 'Add to bag') + ' · ' + money(u * state.qty));
      }
    }

    var sticky = $('stickyBtn');
    if (sticky) { sticky.disabled = !!soldOut; sticky.textContent = soldOut ? tt('sold_out', 'Sold out') : tt('add_to_bag', 'Add to bag'); }
    var grindLbl = state.grind ? ((DATA.grindLabels || {})[state.grind] || state.grind) : '';
    if (CUR_HTML) {
      var sm = $('stickyMeta');
      if (sm) sm.innerHTML = esc((v ? v.sizeLabel : '') + (grindLbl ? ' · ' + grindLbl : '') + ' · ') + moneyHtml(u) +
        esc(state.plan === 'sub' ? tt('per_delivery', ' / delivery') : '');
    } else {
    setText('stickyMeta', (v ? v.sizeLabel : '') + (state.grind ? ' · ' + state.grind : '') + ' · ' + money(u) +
      (state.plan === 'sub' ? ' / delivery' : ''));
    }

    if (v && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
  }

  /* ---------- size / grind pickers ---------- */
  function pickerHandler(containerId, attr, key) {
    var c = $(containerId);
    if (!c) return;
    c.addEventListener('click', function (e) {
      var b = e.target.closest('[data-' + attr + ']');
      if (!b) return;
      state[key] = b.getAttribute('data-' + attr);
      c.querySelectorAll('.vbtn').forEach(function (x) { x.classList.toggle('selected', x === b); });
      update();
    });
  }
  pickerHandler('sizeBtns', 'size', 'size');
  pickerHandler('grindBtns', 'grind', 'grind');

  /* ---------- purchase-type toggle ---------- */
  var planBtns = $('planBtns');
  if (planBtns) {
    planBtns.addEventListener('click', function (e) {
      var b = e.target.closest('[data-plan]');
      if (!b) return;
      state.plan = b.getAttribute('data-plan');
      planBtns.querySelectorAll('.plan').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('selected', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var extra = $('planExtra');
      if (extra) extra.classList.toggle('open', state.plan === 'sub');
      update();
    });
  }
  var freq = $('freq');
  if (freq) freq.addEventListener('change', function (e) { state.planId = e.target.value; update(); });

  /* ---------- qty stepper ---------- */
  var qi = $('qtyInc'), qd = $('qtyDec');
  if (qi) qi.addEventListener('click', function () { state.qty = Math.min(9, state.qty + 1); update(); });
  if (qd) qd.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); update(); });

  /* ---------- gallery ---------- */
  var thumbs = root.querySelector('.g-thumbs');
  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('.g-thumb');
      if (!b) return;
      var idx = b.getAttribute('data-slot');
      thumbs.querySelectorAll('.g-thumb').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('active', on);
        x.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      $$('[data-slot-panel]').forEach(function (p) {
        var on = p.getAttribute('data-slot-panel') === idx;
        p.hidden = !on;
        var f = p.querySelector('iframe[data-src]');
        if (f) { if (!on && f.src) f.removeAttribute('src'); else if (on && !f.src) f.src = f.getAttribute('data-src'); }
      });
    });
  }

  /* ---------- brew guide tabs ---------- */
  var brewTabs = $('brewTabs');
  if (brewTabs) {
    brewTabs.addEventListener('click', function (e) {
      var b = e.target.closest('.tab');
      if (!b) return;
      var method = b.getAttribute('data-method');
      brewTabs.querySelectorAll('.tab').forEach(function (x) { x.classList.toggle('active', x === b); });
      $$('[data-recipe-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-recipe-panel') !== method;
      });
    });
  }

  /* ---------- overlays: Coffee Profile modal ---------- */
  var openOverlay = null, lastTrigger = null, savedScroll = 0;
  var backdrop = $('bbpBackdrop');

  function lockBody() {
    savedScroll = window.scrollY;
    document.body.style.top = '-' + savedScroll + 'px';
    document.body.classList.add('bbp-locked');
  }
  function unlockBody() {
    document.body.classList.remove('bbp-locked');
    document.body.style.top = '';
    window.scrollTo({ top: savedScroll, behavior: 'instant' });
  }
  function openOverlayEl(el, trigger) {
    if (!el) return;
    if (openOverlay) closeOverlay(false);
    openOverlay = el;
    lastTrigger = trigger || null;
    if (backdrop) backdrop.classList.add('open');
    el.classList.add('show');
    lockBody();
    var c = el.querySelector('[data-bbp-close]');
    if (c) c.focus();
  }
  function closeOverlay(restore) {
    if (!openOverlay) return;
    openOverlay.classList.remove('show');
    if (backdrop) backdrop.classList.remove('open');
    unlockBody();
    if (restore !== false && lastTrigger) lastTrigger.focus();
    openOverlay = null;
  }
  if (backdrop) backdrop.addEventListener('click', function () { closeOverlay(); });
  $$('[data-bbp-close]').forEach(function (b) { b.addEventListener('click', function () { closeOverlay(); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOverlay(); });

  var profileModal = $('profileModal');
  var profileOpen = $('profileOpen');
  if (profileOpen && profileModal) {
    profileOpen.addEventListener('click', function (e) { openOverlayEl(profileModal, e.currentTarget); });
  }
  /* Native `{% form 'customer' %}` round-trips the page (POST → redirect → GET).
     On the reload where it succeeded (or failed validation), reopen the modal
     so the confirmation/error rendered server-side is actually seen.
     `form.posted_successfully?` is only valid Liquid scope INSIDE the
     `{% form %}...{% endform %}` block, so detection markers are rendered
     there (not as attributes on the outer wrapper, which is always false). */
  var profileSuccessMarker = $('bbpFormSuccess');
  var profileErrorMarker = $('bbpFormError');
  if (profileModal && (profileSuccessMarker || profileErrorMarker)) {
    openOverlayEl(profileModal, null);
    if (profileSuccessMarker) toast(tt('profile_started', 'Coffee Profile started — check your inbox.'));
  }

  /* ---------- add to cart (real Shopify) ---------- */
  function toast(msg) {
    var t = $('bbpToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  function addToCart() {
    var v = currentVariant();
    if (!v || v.available === false) return;

    var payload = { id: v.id, quantity: state.qty };
    if (state.plan === 'sub' && state.planId) payload.selling_plan = Number(state.planId);
    if (!v.grindIsOption && state.grind) payload.properties = { Grind: state.grind };

    var btns = [$('atcBtn'), $('stickyBtn')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description || tt('could_not_add', 'Could not add to bag'));
        // NOTE: no GA4 add_to_cart here — the parent theme already fires one.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { source: 'bb-pdp' } }));
        toast(BT.added ? tt('added', '', { name: DATA.productTitle }) : DATA.productTitle + ' added to your bag.');
        /* The dispatches above go to no listener: nothing in this theme's header
           subscribes to cart:refresh/cart:change, so the badge stayed at its
           page-load value until the customer opened the cart — caught by
           Salem's tester 28 Jul, on this exact product page. add.js's own
           response is the added line, not the cart total, so a follow-up
           /cart.js read is needed for the true count. */
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var n = cart.item_count || 0, txt = n < 100 ? String(n) : '99+';
          /* document-scoped, not root-scoped: the badge lives in the header,
             outside [data-bbp-root]. $() above is deliberately root-only for
             everything else in this file — this is the one exception. */
          Array.prototype.forEach.call(document.querySelectorAll('.bb-cartbadge'), function (el) { el.textContent = txt; });
          Array.prototype.forEach.call(document.querySelectorAll('.bb-icb.bb-cart, .bb-meta-item.bb-meta-cart'), function (el) {
            el.setAttribute('aria-label', BT.cart_aria ? tt('cart_aria', '', { n: n }) : 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
          });
        }).catch(function () {});
      })
      .catch(function (err) { toast(err.message || tt('wrong', 'Something went wrong — please try again.')); })
      .finally(function () { btns.forEach(function (b) { b.disabled = false; }); update(); });
  }

  /* C3 (28 Jul): both buttons render `disabled` in the markup (see
     bb-pdp-coffee.liquid) so a click during the pre-hydration window is an
     honest no-op (dimmed, not-allowed cursor) instead of a silently swallowed
     click on a bare type="button" with no listener yet. Enable each button in
     the exact same statement that attaches its listener, so there is no tick
     where it's clickable but unbound. */
  var atcBtn = $('atcBtn'), stickyBtn = $('stickyBtn');
  if (atcBtn) { atcBtn.addEventListener('click', addToCart); atcBtn.disabled = false; atcBtn.removeAttribute('aria-disabled'); }
  if (stickyBtn) { stickyBtn.addEventListener('click', addToCart); stickyBtn.disabled = false; stickyBtn.removeAttribute('aria-disabled'); }

  /* ---------- sticky mobile ATC ---------- */
  var sticky = $('stickyAtc');
  if (sticky && atcBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(atcBtn);
  }

  update();
})();
